<template>
	<el-form ref="form" :model="form" label-width="80px">
		<el-form-item label="姓名" prop="name" :rules="[{required: true, message: '姓名不能为空', trigger: 'blur'}]">
			<el-input v-model="form.name" prop="form.name" placeholder="请输入联系人姓名"></el-input>
		</el-form-item>
		<el-form-item label="手机号" prop="phone"
			:rules="[{min:11,max:11,required: true, message: '手机号格式不正确', trigger: 'blur'}]">
			<el-input v-model="form.phone" placeholder="请输入联系人手机号"></el-input>
		</el-form-item>
		<el-form-item label="邮箱">
			<el-input v-model="form.email" placeholder="请输入联系人邮箱"></el-input>
		</el-form-item>
		<el-form-item label="邮编">
			<el-input v-model="form.postcode" placeholder="请输入联系人邮编"></el-input>
		</el-form-item>
		<el-form-item label="省市区">
			<div class="disf jc-s">
				<el-select v-model="form.province_id" placeholder="请选择省" class="wp30" @change="provinceChange">
					<el-option :label="province.provinceName" :value="province.provinceId"
						v-for="province in provinceList">
					</el-option>
				</el-select>
				<el-select v-model="form.city_id" placeholder="请选择市" class="wp30" @change="cityChange">
					<el-option :label="city.cityName" :value="city.cityId" v-for="city in cityList"></el-option>
				</el-select>
				<el-select v-model="form.areas_id" placeholder="请选择区" class="wp30" @change="areasChange">
					<el-option :label="arears.areaName" :value="arears.areaId" v-for="arears in arearsList"></el-option>
				</el-select>
			</div>
		</el-form-item>
		<el-form-item label="详细地址">
			<el-input v-model="form.address" placeholder="请输入联系人详细地址"></el-input>
		</el-form-item>
	</el-form>
</template>

<script>
	export default {
		data() {
			return {
				provinceList: [],
				cityList: [],
				arearsList: [],
				form: {
					id: 0,
					name: "",
					phone: "",
					province_id: undefined,
					province_name: "",
					city_id: undefined,
					city_name: "",
					areas_id: undefined,
					areas_name: "",
					email: "",
					postcode: "",
					address: "",
				}
			};
		},

		methods: {
			init(memberContact) {
				let provinceId = 0;
				let cityId = 0;
				if (memberContact !== undefined) {
					provinceId = memberContact.province_id == undefined ? 0 : memberContact.province_id;
					cityId = memberContact.city_id == undefined ? 0 : memberContact.city_id;
				}

				this.$api.addr
					.getAddrInfo(provinceId, cityId)
					.then((res) => {
						console.log('getAddrInfo res', res);
						this.provinceList = res.Item1;
						this.cityList = res.Item2;
						this.arearsList = res.Item3;
					})
					.catch((res) => {});

				// this.$api.addr
				// 	.getProvince()
				// 	.then((res) => {
				// 		this.provinceList = res;
				// 		console.log("省列表", res);
				// 	})
				// 	.catch((res) => {});

				if (memberContact != undefined) {
					console.log("会员数据", memberContact);
					this.form.id = memberContact.id;
					this.form.name = memberContact.name;
					this.form.phone = memberContact.phone;
					if (memberContact.province_id != 0) {
						this.form.province_id = memberContact.province_id;
					}
					if (memberContact.city_id != 0) {
						this.form.city_id = memberContact.city_id;
					}
					if (memberContact.areas_id != 0) {
								this.form.areas_id = memberContact.areas_id;
							}

					// this.$api.addr
					// 	.getCitys(memberContact.province_id)
					// 	.then((res) => {
					// 		this.cityList = res;
					// 	})
					// 	.catch((res) => {});

					// this.$api.addr
					// 	.getAreas(memberContact.city_id)
					// 	.then((res) => {
					// 		this.arearsList = res;
					// 	})
					// 	.catch((res) => {});
					this.form.email = memberContact.email;
					this.form.postcode = memberContact.postcode;
					this.form.address = memberContact.address;
				}
			},

			// 获取市列表数据
			getCitys(pId) {
				this.$api.addr
					.getCitys(pId)
					.then((res) => {
						this.cityList = res;
					})
					.catch((res) => {});
			},

			// 获取区列表数据
			getAreas(cId) {
				this.$api.addr
					.getAreas(cId)
					.then((res) => {
						console.log("返回的区数据", res);
						this.arearsList = res;
					})
					.catch((res) => {});
			},

			// 省下拉框变化
			provinceChange(val){
				this.form.city_id = undefined;
				this.form.areas_id = undefined;
				this.form.province_id = val;
				this.getCitys(val);
			},
			
			// 市数据变化
			cityChange(val){
				this.form.areas_id = undefined;
				this.form.city_id = val;
				this.getAreas(val);
			},
			
			// 区选择数据发生变化
			areasChange(val){
				this.form.areas_id = val;
			},

			yes(close) {
				if (this.form.name === "" || this.form.phone === "") {
					V.alertError("联系人姓名或手机号不能为空", 2000);
					return;
				}
				if (this.form.phone != "" && this.form.phone.length != 11) {
					V.alertError("手机号格式有误", 2000);
					return;
				}
				if (this.form.areas_id === undefined || this.form.areas_id.length === 0) {
					V.alertError("选择省市区", 2000);
					return;
				}

				let upData = this.form;
				upData.member_id = this.memberId;
				upData.province_name = this.provinceList.find(x => x.provinceId == upData.province_id).provinceName;
				upData.city_name = this.cityList.find(x => x.cityId == upData.city_id).cityName;
				upData.areas_name = this.arearsList.find(x => x.areaId == upData.areas_id).areaName;

				if (upData.id == 0) {
					this.$api.contribute
						.submitContact(upData)
						.then((res) => {
							if (res.Status == 1) {
								this.alert("提交成功", 2000);
								this.$emit("ok");
								close();
							} else {
								this.alertError(res.Data, 2000);
							}
						})
						.catch((r) => {});
				} else {
					this.$api.contribute
						.modifyContact(upData)
						.then((res) => {
							if (res.Status == 1) {
								this.alert("提交成功", 2000);
								this.$emit("ok");
								close();
							} else {
								this.alertError(res.Data, 2000);
							}
						})
						.catch((r) => {});
				}

			},
		},
	};
</script>
